import React, { useEffect, useState } from 'react';
import DefaultLayout from '../layouts/DefaultLayout';
import { useNavigate } from 'react-router-dom';


const Login: React.FC = () => {

    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const navigate = useNavigate();

    const isLoggedIn = async () => {
        const response = await fetch(process.env.REACT_APP_BACKEND_BASE_URL + 'api/me', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include",
        });

        if (!response.ok) {
            throw new Error('Erreur lors de la vérification de la connexion');
        }
        
        const data = await response.json();

        return data && data.id;
    }

    const login = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const response = await fetch(process.env.REACT_APP_BACKEND_BASE_URL + 'api/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include",
            body: JSON.stringify({"username": username, "password": password}),
        });

        if (!response.ok) {
            throw new Error('Erreur lors de la connexion');
        }

        navigate("/");
    }

    const updateUsername = (event: React.ChangeEvent<HTMLInputElement>) => setUsername(event.target.value);
    const updatePassword = (event: React.ChangeEvent<HTMLInputElement>) => setPassword(event.target.value);

    useEffect(() => {
        isLoggedIn().then((loggedIn) => {
            if (loggedIn) {
                navigate("/");
            }
        }).catch((error) => {
            console.error('Erreur lors de la vérification de la connexion:', error);
        });
    }, [navigate]);

    return (
        <DefaultLayout withoutMenu={true}>
            <form onSubmit={login}>
                <div className="mb-3">
                    <label htmlFor="username" className="form-label">Utilisateur</label>
                    <input onChange={updateUsername} value={username} type="input" name="username" className="form-control" id="username" aria-describedby="usernameHelp" />
                    <div id="usernameHelp" className="form-text">Entrez votre nom d&apos;utilisateur.</div>
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className="form-label">Mot de passe</label>
                    <input onChange={updatePassword} value={password} type="password" className="form-control" id="password" aria-describedby="passwordHelp" />
                    <div id="passwordHelp" className="form-text">Entrez votre mot de passe.</div>
                </div>
                <button type="submit" className="btn btn-primary">Se connecter</button>
            </form>
        </DefaultLayout>
    );
}

export default Login;